const getFirstPartTimestamp = (store) => {
  return store.firstPartTimestamp;
};

export { getFirstPartTimestamp };
